export interface AdSpotLabelSource {
  title: string
  campaignName?: string | null
  campaign?: { name?: string | null } | null
}

/**
 * Libellé opérateur d'un spot publicitaire. Le titre seul est souvent partagé
 * par plusieurs campagnes : garder la campagne sur la même ligne évite de
 * sélectionner le mauvais média dans une liste compacte.
 */
export function formatAdSpotLabel(spot: AdSpotLabelSource): string {
  const campaignName = spot.campaignName?.trim() || spot.campaign?.name?.trim()
  return campaignName ? `${spot.title} - ${campaignName}` : spot.title
}
